export const convertDecimalCurrency = (str) => {
  if (typeof str === 'string') {
    return parseFloat(str.replace(/,/g, '.'))?.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })
  } else {
    return str?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
  }
}

export const convertDecimalCurrencyTest = (str) => {
  return str?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

export const formatarParaPorcentagem = (numero) => {
  const numeroFormatado = parseFloat(numero).toFixed(2)
  const numeroComVirgula = numeroFormatado.replace('.', ',')
  return `${numeroComVirgula}%`
}
export const converterParaNumero = (valorString) => {
  // Remove todos os caracteres não numéricos, exceto vírgula
  const valorLimpo = valorString.replace(/[^\d,]/g, '')
  // Converte para número e retorna
  const numero = parseFloat(valorLimpo.replace(',', '.'))
  return numero
}

export const convertDecimalPercentage = (str) => {
  return (str * 100)?.toLocaleString('pt-BR', { minimumSignificantDigits: 3 })
}

export const capitalizeWord = (str) => {
  return (
    str?.toLowerCase()?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase()
  )
}

export const capitalizePhrase = (str) => {
  return (
    str &&
    str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
      .join(' ')
  )
}

export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

export const noSpecialChars = (value) => {
  return value.replace(/[^a-z0-9àèìòùáéíóúâêîôûãõç\s]/gi, '')
}

export const removeSecondsFromTime = (value) => {
  const time = value?.slice(0, 6).split(':')
  return `${time[0]}:${time[1]}`
}

export const precoMask = (val = 0) => {
  val = 'R$ ' + val.toFixed(2)
  return val.replace('.', ',')
}

export const onlyNumber = (value) => {
  return value.replace(/[^0-9]/g, '')
}

export const tokenMask = (value) => {
  return value
    .toUpperCase()
    .replace(/[^0-9A-Z]/g, '')
    .replace(/([0-9A-Z]{4})([0-9A-Z])/, '$1-$2')
    .replace(/([0-9A-Z]{4})([0-9A-Z])/, '$1-$2')
    .replace(/([0-9A-Z]{4})([0-9A-Z])/, '$1-$2')
    .replace(
      /([0-9A-Z]{4}-[0-9A-Z]{4}-[0-9A-Z]{4}-[0-9A-Z]{4})[0-9A-Z]+?$/,
      '$1'
    )
}

export const showFullFlagName = (flag) => {
  if (flag === 'Amex') {
    return 'American Express'
  } else if (flag === 'Diners') {
    return "Diner's Club"
  } else {
    return flag
  }
}

export function range(start, end) {
  return Array(end - start + 1)
    .fill()
    .map((_, idx) => start + idx)
}

export function arrayMonths() {
  return {
    1: 'Janeiro',
    2: 'Fevereiro',
    3: 'Março',
    4: 'Abril',
    5: 'Maio',
    6: 'Junho',
    7: 'Julho',
    8: 'Agosto',
    9: 'Setembro',
    10: 'Outubro',
    11: 'Novembro',
    12: 'Dezembro'
  }
}
